import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PlannerCard from "./PlannerCard";
import NotPlannedContainer from "../../containers/schedule/NotPlannedContainer";
import RefereesCard from "./RefereesCard";
// import IconButton from "@material-ui/core/IconButton";
// import CloseIcon from "@material-ui/icons/Close";
import clsx from "clsx";
import Icon from "@mdi/react";
import { mdiCalendarClock } from "@mdi/js";
import { mdiWhistle } from "@mdi/js";
import { mdiCalendarRemove } from "@mdi/js";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";

const drawerWidth = 320;

const styles = theme => ({
  root: {
    width: "100%",
    height: "100%",
    // marginTop: theme.spacing(1),
    zIndex: 1,
    overflow: "hidden"
  },
  appFrame: {
    position: "relative",
    display: "flex",
    width: "100%",
    height: "100%"
  },
  drawerHeader: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      position: "fixed",
      height: "100%"
    },
    borderRight: "0",
    backgroundColor: "white",
    zIndex: 10,
    overflowX: "hidden"
  },
  content: {
    backgroundColor: theme.palette.background.default,
    width: "calc(100% - 312px)",
    marginRight: drawerWidth - 8,
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      marginRight: 0
    }
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginRight: 0,
    width: "100%"
  },
  tabRoot: { minWidth: 99 }
});

class SideSheet extends React.Component {
  state = {
    value: 0
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { classes } = this.props;
    const drawer = (
      <div style={{ width: "100%", overflowY: "hidden" }}>
        <div className={classes.drawerHeader} />
        {/* <Hidden smUp>
          <IconButton onClick={this.props.handleSideSheetExpandClick}>
            <CloseIcon />
          </IconButton>
        </Hidden> */}
        <Tabs
          value={this.state.value}
          onChange={this.handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant={"standard"}
          scrollButtons="off"
          style={{
            marginTop: 12,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            height: 40
          }}
        >
          <Tab
            key={0}
            icon={
              <Icon
                path={mdiCalendarClock}
                size={1}
                color={
                  this.state.value === 0
                    ? this.props.theme.palette.primary.main
                    : "rgba(0, 0, 0, 0.54)"
                }
              />
            }
            classes={{
              root: classes.tabRoot
            }}
          />
          <Tab
            key={1}
            icon={
              <Icon
                path={mdiWhistle}
                size={1}
                color={
                  this.state.value === 1
                    ? this.props.theme.palette.primary.main
                    : "rgba(0, 0, 0, 0.54)"
                }
              />
            }
            classes={{
              root: classes.tabRoot
            }}
          />
          <Tab
            key={2}
            icon={
              <Icon
                path={mdiCalendarRemove}
                size={1}
                color={
                  this.state.value === 2
                    ? this.props.theme.palette.primary.main
                    : "rgba(0, 0, 0, 0.54)"
                }
              />
            }
            classes={{
              root: classes.tabRoot
            }}
          />
        </Tabs>
        <div hidden={this.state.value !== 0}>
          <PlannerCard {...this.props} />
        </div>
        {this.state.value === 1 && <RefereesCard {...this.props} />}
        {this.state.value === 2 && <NotPlannedContainer {...this.props} />}
      </div>
    );

    return (
      <div className={classes.root}>
        <div className={classes.appFrame}>
          <Hidden smUp>
            <SwipeableDrawer
              variant="temporary"
              anchor={"right"}
              open={
                this.props.sideSheetExpandedMobile && !this.props.supportOpen
              }
              classes={{
                paper: classes.drawerPaper
              }}
              // onClose={this.props.handleDrawerToggleMobile}
              ModalProps={{
                style: { zIndex: 2 },
                keepMounted: true // Better open performance on mobile.
              }}
              onClose={this.props.handleSideSheetExpandClick}
              onOpen={this.props.handleSideSheetExpandClick}
              disableDiscovery={true}
            >
              {drawer}
            </SwipeableDrawer>
          </Hidden>
          <Hidden xsDown implementation="css">
            <Drawer
              variant="persistent"
              open={this.props.sideSheetExpanded && !this.props.supportOpen}
              classes={{
                paper: classes.drawerPaper
              }}
              anchor={"right"}
            >
              {drawer}
            </Drawer>
          </Hidden>

          <main
            className={clsx(classes.content, {
              [classes.contentShift]:
                !this.props.sideSheetExpanded || this.props.supportOpen
            })}
          >
            {this.props.children}
          </main>
        </div>
      </div>
    );
  }
}

SideSheet.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(SideSheet);
